<template>
    <div style="width: 100%;height: 100%;">
        <div style="width: 100%;background-color: #fff;">
            <AchievementsHeader />
            <div style="overflow: hidden;">
                <div class="industrialBox">
                    <div class="industrialContentBox">
                        <div class="industrialContent">
                            <div class="industrialContentLeft">
                                <a-carousel arrows autoplay :dots="false" :slides-to-show="1">
                                    <template #prevArrow>
                                        <div class="lef" style="display: none;" />
                                    </template>
                                    <template #nextArrow>
                                        <div class="rig" style="display: none;" />
                                    </template>
                                    <div class="imgBox" style="width: 100%;height: 370px" v-for="item in zhiku"
                                        :key="item.id">
                                        <img v-if="item.thumbnail" :src="getImg(item.thumbnail)" alt="">
                                        <img v-else src="@/assets/img/defaultImg.png" alt="">
                                    </div>
                                </a-carousel>
                            </div>
                            <div class="industrialContentRight">
                                <div class="industrialTitleBox">
                                    <div class="industrialTitle">
                                        通知公告
                                    </div>
                                    <div class="MoreBox"
                                        @click="goMore('/achievements/components/consultation', { type: '通知公告' })">
                                        更多 ></div>
                                </div>
                                <a-list size="large" :data-source="zhiku">
                                    <template #renderItem="{ item }">
                                        <a-list-item @click="goDetail(item.id)">
                                            <div class="left">
                                                <span>{{ item.title }}</span>
                                            </div>
                                            <div class="right">
                                                <span> {{ item.publishTime ? item.publishTime.split(' ')[0] : '' }} </span>
                                            </div>
                                        </a-list-item>
                                    </template>
                                </a-list>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="smallBanner" @click="goMore('/achievements/components/agreement', { type: '技术合同' })">
                    <img src="@/assets/img/achievementslong.jpg" alt="">
                </div>
                <div class="talentBox">
                    <div class="leftBox"
                        @click="goMore('/achievements/components/achievementRequirements', { type: '成果交易', activeKey: '1' })">
                        <img src="@/assets/img/jszr.jpg" alt="">
                    </div>
                    <div class="rightBox"
                        @click="goMore('/achievements/components/achievementRequirements', { type: '成果交易', activeKey: '2' })">
                        <img src="@/assets/img/achievementsRight.jpg" alt="">
                    </div>
                </div>
                <div class="recruitmentBox">
                    <div class="recruitmentTitleBox">
                        <div class="recruitmentTitle">
                            <span class="ml-20 mr-20" :class="Jd == '1' ? 'active' : ''" @click="changeJD('1')">中试基地</span>
                            <span @click="changeJD('2')" :class="Jd == '2' ? 'active' : ''">成果转化示范基地</span>
                        </div>
                        <div class="MoreBox" @click="goMore('/achievements/components/achievement', { type: '成果展示' })">更多 >
                        </div>
                    </div>
                    <div class="recruitmentContentBox" :class="Jd == '1' ? 'boxLife' : 'boxDie'">
                        <div class="recruitmentSmallBox">
                            <div class="recruitmentSmallInfo" v-for="(item, index) in recruitmentData" :key="index"
                                @click="goMore('/achievements/components/achievementDetails', { type: '成果展示', id: item.id })">
                                <div class="mask"></div>
                                <div class="btn">
                                    <a-button style="background-color: #fc550b;color: #fff;">查看详情</a-button>
                                </div>
                                <div class="recruitmentBottomBox">
                                    <div style="display: flex;">
                                        <div class="recruitmentBottomTopBox">
                                            <img :src="getImg(item.aimg)" alt="">
                                        </div>
                                        <div>
                                            <div class="recruitmentBottomMiddleBox">{{ item.aname }}
                                                <div class="recruitmentBottomRightBottom">
                                                </div>
                                            </div>
                                            <div class="recruitmentBottomBottomBox">{{ item.acontent }}</div>
                                            <!-- <div class="recruitmentBottomBottomBottomBox">
                                                <p>技术成熟度：
                                                    <dict-render :dict-obj="dictObjs['technical_maturity']"
                                                        v-if="item.techMaturity" :text="item.techMaturity"></dict-render>
                                                </p>
                                                <p>合作方式：
                                                    <dict-render :dict-obj="dictObjs['cooperation_methods']"
                                                        v-if="item.cooperationWay"
                                                        :text="item.cooperationWay"></dict-render>
                                                </p>
                                            </div> -->
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="recruitmentContentBox" :class="Jd == '2' ? 'boxLife' : 'boxDie'">
                        <div class="recruitmentSmallBox">
                            <div class="recruitmentSmallInfo" v-for="(item, index) in recruitmentData" :key="index"
                                @click="goMore('/achievements/components/achievementDetails', { type: '科技成果', id: item.id })">
                                <div class="mask"></div>
                                <div class="btn">
                                    <a-button style="background-color: #fc550b;color: #fff;">查看详情</a-button>
                                </div>
                                <div class="recruitmentBottomBox">
                                    <div style="display: flex;">
                                        <div class="recruitmentBottomTopBox">
                                            <img :src="getImg(item.aimg)" alt="">
                                        </div>
                                        <div>
                                            <div class="recruitmentBottomMiddleBox">{{ item.aname }}
                                                <div class="recruitmentBottomRightBottom">
                                                </div>
                                            </div>
                                            <div class="recruitmentBottomBottomBox">{{ item.acontent }}</div>
                                            <!-- <div class="recruitmentBottomBottomBottomBox">
                                                <p>技术成熟度1：
                                                    <dict-render :dict-obj="dictObjs['technical_maturity']"
                                                        v-if="item.techMaturity" :text="item.techMaturity"></dict-render>
                                                </p>
                                                <p>合作方式：
                                                    <dict-render :dict-obj="dictObjs['cooperation_methods']"
                                                        v-if="item.cooperationWay"
                                                        :text="item.cooperationWay"></dict-render>
                                                </p>
                                            </div> -->
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <LayoutFooter />
    </div>
</template>

<script>
import { platformName } from "@/config/platformConfig";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import AchievementsHeader from './components/achievementsHeader';
import { homeEducationInfo, entrepreneurshipMentor } from '@/api/educationService';
import { basicsAchievement } from "@/api/achievementsService";
import { noticeWeb } from "@/api/innovationService";
import { file_service } from "@/api/adminService";
import { dictMixin } from "@/mixins";
// import DictRender from '@/components/other/DictRender';

export default {
    name: "index",
    mixins: [dictMixin],
    components: {
        LayoutFooter,
        AchievementsHeader,
        // DictRender
    },
    data() {
        return {
            dictNames: 'technical_maturity,cooperation_methods,businessScope,projecttype,education_background,professionalTitle,research_field,thinktank_type',
            platformName,
            current: ['首页'],
            clickMenuTitle: '',
            formState: {
                user: null,
            },
            formSearchBox: {
                city: null,
                company: null,
                project: null,
                demand: null
            },
            recruitmentData: [],
            achData:[],
            teacherData: [],
            findPeopleList: [],
            zhiku: [],
            Jd: '1',
        }
    },
    created() {
        this.getJobList(1)
        this.getZhikuList()
        this.getTutorList()
        this.getFindPeople()
    },
    methods: {
        goMore(url, params) {
            this.$router.push({
                path: url,
                query: params
            })
        },
        goDetail(id) {
            this.$router.push({
                path: "/achievements/components/noticeDetail",
                query: { id: id, type: "首页" }
            })
        },
        menuClick(e) {
            this.clickMenuTitle = e.item.title
        },
        backhome() {
            this.$router.push('/')
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getJobList(type) {
            this.getAction({
                url: basicsAchievement.pageList,
                params: { atype: type }
            }).then(res => {
                this.recruitmentData = res.records
            })
        },
        getZhikuList() {
            this.getAction({
                url: noticeWeb.pageList,
                params: { pageNum: 1, pageSize: 8 }
            }).then(res => {
                this.zhiku = res.records
            })
        },
        getTutorList() {
            this.getAction({
                url: entrepreneurshipMentor.pageList
            }).then(res => {
                this.teacherData = res.records
            })
        },
        getFindPeople() {
            this.getAction({
                url: homeEducationInfo.findpeopleList
            }).then(res => {
                this.findPeopleList = res.records
            })
        },
        changeJD(id) {
            this.Jd = id
            this.getJobList(id)
        }
    }
}
</script>

<style scoped lang="less">
.smallHeaderBox {
    overflow: hidden;
    width: 100%;
    background-color: #ecf0f6;
    color: #666666;
    font-size: 14px;
    padding: 10px 0;

    .smallHeader {
        float: left;
    }

    .backhome {
        float: right;
        cursor: pointer;
        color: #1890ff;
    }
}

.headerBox {
    width: 100%;
    height: 92px;
    background-color: #fff;

    .hearderContentBox {
        overflow: hidden;
        width: 1200px;
        margin: 0 auto;

        .titleBox {
            float: left;
            line-height: 92px;
            font-size: 30px;
            font-weight: bold;
            color: #035aea;
        }

        .rightBox {
            float: right;
            margin-top: 2.5%;
        }
    }
}

.menuTopBox {
    margin: 0 auto;
    width: 1200px;
    background-color: #fff;

    .menuTopContent {
        margin: 0 auto;

        :deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item) {
            width: 14%;
            text-align: center;
        }

        :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected) {
            background-color: #1d72ff;
            color: #fff;
        }

        :deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
            border: none;
        }
    }
}

.bannerBox {
    position: relative;
    width: 100%;
    height: 280px;

    .bannerImg {
        width: 100%;
        height: 280px;
    }
}


.smallBanner {
    margin: 10px auto 20px auto;
    width: 1200px;
    height: 120px;
    cursor: pointer;

    img {
        width: 100%;
        height: 100%;
    }
}

.industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialContentBox {
        overflow: hidden;

        .industrialContent {
            overflow: hidden;
            width: 100%;

            .industrialContentLeft {
                float: left;
                width: 55%;
                height: 370px;

                .lef {
                    display: none !important;
                    background-image: url('../../assets/img/jianlef.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    z-index: 1;
                    width: 2rem;
                    left: 0;
                    height: 2rem;
                    border-radius: 50%;
                }

                .lef:hover {
                    background-image: url('../../assets/img/jianlefh.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    z-index: 1;
                    border-radius: 50%;
                }

                .rig {
                    display: none !important;
                    background-image: url('../../assets/img/jianrig.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    z-index: 1;
                    width: 2rem;
                    right: 0;
                    height: 2rem;
                    border-radius: 50%;
                }

                .rig:hover {
                    background-image: url('../../assets/img/jianrigh.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    z-index: 1;
                    border-radius: 50%;
                }

                .imgBox {
                    cursor: pointer;
                    width: 35%;
                    height: 370px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }

            .industrialContentLeft:hover {
                .lef {
                    display: block !important;
                }

                .rig {
                    display: block !important;
                }
            }

            .industrialContentRight {
                position: relative;
                // overflow: hidden;
                float: right;
                width: 43%;
                color: #333;
                height: 226px;

                .industrialTitleBox {
                    overflow: hidden;
                    width: 100%;
                    border-bottom: 1px solid #dedede;

                    .industrialTitle {
                        float: left;
                        font-size: 20px;
                        color: #333;
                        padding-bottom: 5px;
                    }

                    .industrialTitle::before {
                        content: '';
                        padding-left: 12px;
                        border-left: 4px solid #fc550b;
                    }

                    .MoreBox {
                        float: right;
                        color: #999;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }

                .industrialContentTitle {
                    font-size: 20px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .industrialContentDesc {
                    margin: 8px 0;
                    font-size: 18px;
                }

                .industrialContentInfo {
                    margin: 8px 0 40px 0;
                    font-size: 14px;
                    color: #666;
                }

                .industrialContentBtn {
                    width: 120px;
                    height: 35px;
                    z-index: 999;

                    .btn {
                        width: 100%;
                        height: 100%;
                    }
                }

                :deep(.ant-list-lg .ant-list-item) {
                    padding: 16px 0;
                    cursor: pointer;
                }

                .left {
                    width: 84%;
                    float: left;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }

                .right {
                    float: right;
                }

                a {
                    color: #000;
                }

                .ant-list-item:hover {
                    color: #0a2c83;
                }

                .ant-list-item .right:hover {
                    color: #0a2c83;
                }
            }
        }
    }
}

.recruitmentBox {
    width: 1200px;
    margin: 20px auto;

    .boxDie {
        display: none;
    }

    .boxLife {
        display: block;
    }

    .recruitmentTitleBox {
        overflow: hidden;
        width: 100%;
        padding: 15px 0 8px 0;
        border-bottom: 1px solid #dedede;

        .recruitmentTitle {
            float: left;
            font-size: 18px;
            font-weight: 900;
            color: #333;
            position: relative;
            cursor: pointer;

            span {
                &:hover {
                    font-size: 20px;
                    color: #fc550b;
                }
            }

        }

        .active {
            font-size: 20px;
            color: #fc550b;
        }

        .recruitmentTitle::before {
            display: block;
            height: 30px;
            content: '';
            padding-left: 12px;
            border-left: 4px solid #035aea;
            position: absolute;
            left: 0;
        }

        .MoreBox {
            float: right;
            color: #999;
            font-size: 14px;
            cursor: pointer;
        }
    }

    .recruitmentContentBox {
        padding: 14px 0 0 0;
        width: 100%;

        .recruitmentSmallBox {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 100%;

            .recruitmentSmallInfo {
                width: 49%;
                border: 1px solid #dedede;
                cursor: pointer;
                margin: 10px 0;
                position: relative;

                .mask {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: none;
                    background-color: #4c4c4c;
                }

                .btn {
                    position: absolute;
                    top: 40%;
                    left: 40%;
                    display: none;
                }

                .recruitmentBottomBox {
                    overflow: hidden;
                    padding: 12px;
                    width: 100%;
                    color: #333;
                    font-size: 14px;
                    // text-align: center;

                    .recruitmentBottomTopBox {
                        width: 304px;
                        height: 170px;
                        margin-right: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .recruitmentBottomMiddleBox {
                        padding: 12px 0;
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .recruitmentBottomBottomBox {
                        color: #666;
                        overflow: hidden;
                        min-height: 42px;
                        margin: 10px 0;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    .recruitmentBottomBottomBottomBox {
                        padding: 8px 0;
                        color: #999;
                    }
                }
            }

            .recruitmentSmallInfo:hover {
                border: none;
                -webkit-transition: all 0.3s ease 0s;
                transition: all 0.3s ease 0s;
                //border: 1px solid #ffffff;
                cursor: pointer;
                -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
                box-shadow: 0 5px 10px 1px #d2e6ff;

                .mask {
                    display: block;
                    opacity: 0.7;
                }

                .btn {
                    display: block;
                }
            }
        }
    }
}

.talentBox {
    overflow: hidden;
    width: 1200px;
    margin: 20px auto;

    .leftBox {
        float: left;
        width: 48%;
        height: 105px;
        margin-right: 1.5%;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .rightBox {
        float: right;
        width: 48%;
        height: 105px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

}

.linkBox {
    overflow: hidden;
    margin: 20px auto 0 auto;
    width: 1200px;

    .linkLeft {
        float: left;
        width: 7%;
        font-size: 20px;
        color: #333;
        line-height: 82px;
    }

    .linkRight {
        float: right;
        width: 90%;
        overflow: hidden;
        padding: 30px 0;
        // display: flex;
        // justify-content: space-around;
        // flex-wrap: wrap;

        .linkRightItem {
            width: 15%;
            color: #333;
            font-size: 14px;
            text-align: center;
            float: left;
        }
    }
}

.ant-btn-background-ghost.ant-btn-primary {
    color: #035aea;
    background-color: #035aea;
}</style>
